export default "__VITE_PUBLIC_ASSET__73374a1c__"